import styled from '@emotion/styled';
import { ifProp } from 'styled-tools';

export const Wrapper = styled.table<{ topMargin?: boolean }>(({ theme, topMargin }) => ({
    width: '100%',
    maxWidth: '600px',
    marginTop: topMargin ? theme.space[4] : 0,
}));

export const SpecificationLine = styled.tr(({ theme }) => ({
    borderBottom: `1px solid ${theme.colors.grey40}`,
}));

export const Specification = styled.td<{ isTitle?: boolean }>(
    ({ theme }) => ({
        fontSize: theme.fontSizes.mouse,
        lineHeight: theme.lineHeights.chicken,
        color: theme.colors.nightBlack,
        padding: theme.space[2],
        paddingLeft: 0,
        width: '50%',
    }),
    ifProp('isTitle', ({ theme }) => ({ fontWeight: theme.fontWeights.medium })),
);
